var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileFunctionality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D5F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14a1 1 0 011-1h16a1 1 0 011 1v20a1 1 0 01-1 1H16a1 1 0 01-1-1V14z",
    stroke: "#21BEE7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32h4",
    stroke: "#21BEE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNENUY2RkYiLz4KPHBhdGggZD0iTTE1IDE0QzE1IDEzLjQ0NzcgMTUuNDQ3NyAxMyAxNiAxM0gzMkMzMi41NTIzIDEzIDMzIDEzLjQ0NzcgMzMgMTRWMjlWMzRDMzMgMzQuNTUyMyAzMi41NTIzIDM1IDMyIDM1SDE2QzE1LjQ0NzcgMzUgMTUgMzQuNTUyMyAxNSAzNFYyOVYxNFoiIHN0cm9rZT0iIzIxQkVFNyIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yMiAzMkgyNiIgc3Ryb2tlPSIjMjFCRUU3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgMobileFunctionality as ReactComponent };